import {hide} from 'react-notification-system-redux';
import 'rxjs/add/operator/map';

import {removeNotification} from '../actions';

// eslint-disable-next-line import/prefer-default-export
export const removeNotifactionEpic = (action$) =>
  action$.ofType(removeNotification.TYPE).map(({payload}) => hide(payload));
